import { t } from '@/plugins/i18n'
export const tableConfig = {
  // showExpand: true
}

export const productColumns:any = [
  {
    label: t('图片'),
    prop: 'productImg',
    align: 'center',
    slotName: 'productImg'
  },
  {
    label: t('sku/平台商品信息'),
    prop: 'productSkuInfo',
    width: 250,
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    slotName: 'customerProductMsku'
  },
  {
    label: t('规格'),
    prop: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('单价'),
    prop: 'productPrice',
    align: 'center',
    slotName: 'productPrice'
  },
  {
    label: t('海外仓sku'),
    prop: 'skuFile',
    align: 'center',
    width: 220,
    slotName: 'skuFile'
  },
  {
    label: t('计划发货数量'),
    prop: 'deliveryNums',
    align: 'center',
    slotName: 'deliveryNums'
  },
  {
    label: t('实际发货数量'),
    prop: 'realDeliveryNums',
    align: 'center',
    slotName: 'realDeliveryNums'
  },
  {
    label: t('小计'),
    prop: 'allPrice',
    align: 'center',
    slotName: 'allPrice'
  }
]
export const AmazonColumns:any = [
  {
    label: t('图片'),
    prop: 'productImg',
    align: 'center',
    slotName: 'productImg'
  },
  {
    label: t('sku/平台商品信息'),
    prop: 'productSkuInfo',
    width: 250,
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center'
  },
  {
    label: t('规格'),
    prop: 'productPropertiesName',
    align: 'center'
  },
  {
    label: t('单价'),
    prop: 'productPrice',
    align: 'center',
    slotName: 'productPrice'
  },
  {
    label: t('AMAZON商品名称'),
    prop: 'amazonProductTitle',
    align: 'center',
    slotName: 'amazonProductTitle'
  },
  {
    label: t('Amazon sku'),
    prop: 'amazonMsku',
    align: 'center'
  },
  {
    label: t('海外仓sku(fnsku)'),
    prop: 'amazonFnsku',
    align: 'center',
    width: 200,
    slotName: 'amazonFnsku'
  },
  {
    label: t('计划发货数量'),
    prop: 'deliveryNums',
    align: 'center',
    slotName: 'deliveryNums'
  },
  {
    label: t('实际发货数量'),
    prop: 'realDeliveryNums',
    align: 'center',
    slotName: 'realDeliveryNums'
  },
  {
    label: t('小计'),
    prop: 'allPrice',
    align: 'center',
    slotName: 'allPrice'
  }
]
export const boxDetailColumns:any = [
  {
    label: t('箱番号'),
    prop: 'deliveryBoxDetailId',
    align: 'center'
  },
  {
    label: t('图片'),
    prop: 'productImg',
    align: 'center',
    slotName: 'productImg'
  },
  {
    label: t('商品情报'),
    prop: 'productSkuInfo',
    width: 250,
    align: 'center',
    slotName: 'productSkuInfo'
  },
  {
    label: t('SKU'),
    prop: 'productSku',
    width: 250,
    align: 'center'
  },
  {
    label: t('商品数量'),
    prop: 'nums',
    width: 250,
    align: 'center'
  }
]
export const boxColumns:any = [
  {
    label: t('名称'),
    prop: 'boxName',
    align: 'center',
    slotName: 'boxName'
  },
  {
    label: t('实际重量') + '(KG)',
    prop: 'weight',
    align: 'center',
    slotName: 'weight'
  },
  {
    label: t('长') + '(cm)',
    prop: 'length',
    align: 'center'
  },
  {
    label: t('宽') + '(cm)',
    prop: 'width',
    align: 'center'
  },
  {
    label: t('高') + '(cm)',
    prop: 'height',
    align: 'center'
  },
  {
    label: t('体积重') + '(KG)',
    prop: 'bulky',
    align: 'center'
  }

]
export const thirdWarehouseTypeDict: any = {
  0: t('其他'),
  1: t('FBA发货'),
  2: t('乐天'),
  3: t('SHOPLIST'),
  4: t('ZOZOTOWN')
}
